import { baseCommand } from "./basecommand";

type itemtypename = "time";

type itemdatatype = {
    "longitude" : number;
    "latitude" : number;
    "timezone" : number;
    "date" : string
}

type pscommand<T> = {
    "type": T extends itemtypename ? T : never;
    "data": T extends itemtypename ? itemdatatype : never;
}

export type placeDateCommand = pscommand<itemtypename>;

export class placeDateStatus extends baseCommand {

    // defalt is 東京都庁
    private longitude: number = 139.7673068;     // 経度
    private latitude: number = 35.6809591;     // 緯度
    // defalt is Japan(GMT+9)
    private timezone: number = +9;
    // defalt is 2022夏至 南中時刻
    private date: string = '2022/10/01 9:00';

    constructor() {
        super();
        this.getDate();
        // this.getPlace();
    }

    public setPlace(longitude: number, latitude: number, timezone: number) {
        this.longitude = longitude;
        this.latitude = latitude;
        this.timezone = timezone;
    }

    public setDate(daytime: string) {
        this.date = daytime;
    }

    public object(): placeDateCommand {
        return {
            "type":"time",
            "data":{
              "longitude" : this.longitude,
              "latitude" : this.latitude,
              "timezone" : this.timezone,
              "date" : this.date
            }
        }
    }

    private getPlace() {
        return new Promise(
            (
              resolve: (position) => void,
              reject: (positionError) => void,
            ) => {
                if (!navigator.geolocation) {
                    // 位置情報APIが利用できない場合
                    // 自前でPositionErrorを作成
                    const error = {
                        code: undefined,
                        message: 'geolocation not supported.',
                        PERMISSION_DENIED: undefined,
                        POSITION_UNAVAILABLE: undefined,
                        TIMEOUT: undefined,
                    }
                    reject(error);
                }

                // 成功時
                const successCallback:PositionCallback = (position): void => {
                    this.longitude = position.coords.longitude;
                    this.latitude = position.coords.latitude;
                    resolve(position);
                }

                // エラー時
                const errorCallback:PositionErrorCallback = (positionError): void => {
                    reject(positionError)
                }

                // 現在位置取得
                navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
        }).then(() => console.log(this.jsonString()));
    }

    private getDate() {
        const date = new Date();
        this.date = date.toLocaleString("ja");
    }

}
